import { imageUrl } from "../constants/constants";

const VideoCard = ({ item }) => {
  return (
    <>
      <div className="photo-gallery-area desc-sec photo-gallery-detail-page video-wrapper csr-video-wrapper">
        <div className="card-sec">
          <div className="img-sec">
            <video
              width="100%"
              height="230px"
              controls={true}
              loop={true}
              muted={true}
            >
              <source
                src={imageUrl + item.field_address_board_directoer}
                type="video/mp4"
              />
            </video>
          </div>
        </div>
        <div className="inner-video-title2 line-clamp line-clamp-2">
          {item.title}
        </div>
      </div>
    </>
  );
};

export default VideoCard;
